var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4H7.45941C6.02937 4 4.79812 5.00938 4.51767 6.41165L3.02733 16.6686M14.5 4H16.5406C17.9706 4 19.2019 5.00938 19.4823 6.41165L20.9727 16.6686M3.02733 16.6686C3.18521 15.7218 4.00832 15 5 15H19C20.1046 15 21 15.8954 21 17V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V17C3 16.8871 3.00935 16.7764 3.02733 16.6686ZM8 8.44444L12 12M12 12L16 8.44444M12 12L12 2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.096d622c7488c5bed7e37dcda5d46aa0.svg";
export { ForwardRef as ReactComponent };